import { render, staticRenderFns } from "./DeliveryAddressRedirect.vue?vue&type=template&id=7b22071e"
import script from "./DeliveryAddressRedirect.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports